module EEX.McEc.Models {

    import CertificateModel = McEc.Domain.CertificateModel;

    export class CertificateContainerModel {

        private certificateContainers: CertificateContainer[];

        constructor() {
            this.certificateContainers = [];
        }

        public addAll(certificates: CertificateModel[]) {
            for (let certificate of certificates) {
                this.certificateContainers.push({
                    certificate: certificate
                });
            }
        }

        public addOne(certificate: CertificateModel) {
            this.certificateContainers.push({
                certificate: certificate
            });
        }

        public add(certificate: CertificateModel, store: Pki.Store, certificateFile: string) {
            this.certificateContainers.push({
                certificate: certificate,
                store: store,
                certificateFile: certificateFile
            });
        }

        public getCertificates() {
            let certificates: CertificateModel[] = [];
            for (let c of this.certificateContainers) {
                certificates.push(c.certificate);
            }
            return certificates;
        }

        public updateAll(certificates: CertificateModel[]) {
            for (let certificate of certificates) {
                let cc = this.find(certificate);
                if (cc) {
                    cc.certificate = certificate;
                } else {
                    this.addOne(certificate);
                }
            }
        }

        public updateByKey(certificateKey: number, store: Pki.Store, certificateFile: string) {
            let cc = this.findByKey(certificateKey);
            if (cc) {
                cc.store = store;
                cc.certificateFile = certificateFile;
            }
        }

        public update(certificate: CertificateModel, store: Pki.Store, certificateFile: string) {
            let cc = this.find(certificate);
            if (cc) {
                cc.certificate = certificate;
                cc.store = store;
                cc.certificateFile = certificateFile;
            } else {
                this.add(certificate, store, certificateFile);
            }
        }

        private find(certificate: CertificateModel): CertificateContainer {
            for (let cc of this.certificateContainers) {
                if (certificate.Key === cc.certificate.Key) {
                    return cc;
                }
            }
            return null;
        }

        public findByKey(certificateKey: number): CertificateContainer {
            for (let cc of this.certificateContainers) {
                if (certificateKey === cc.certificate.Key) {
                    return cc;
                }
            }
            return null;
        }
            
    }
}
